<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("vincular-usuario") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="usuariosSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-usuario"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="usuarios"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="usuariosSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idusuario === linha.idusuario"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import UsuarioService from '@/services/vendas/empresa/abas/AssUsuarioEmpresaService';
import Message from "@/models/Message";

export default {
    props: {
        idempresa: 0,
    },
    data() {
        return {
            service: new UsuarioService(this.$http, this.$router),
            usuarios: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null }
            ],
            usuariosSelecionados: [],
            idusuario: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
            userSelfUpdate: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isDespesa: this.$route.meta.contexto == "despesas",
            isPromotor: this.$route.meta.contexto == "promotor",
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findUsuariosNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idempresa,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.usuarios = value;
                this.isEmpty = this.usuarios.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findUsuariosNaoAssociados(column, order, page, limit, idempresa, ...params) {
            if (this.isVenda) {
                return this.service
                .findUsuariosNaoAssociadosVendas(column, order, page, limit, idempresa, ...params);
            }else if (this.isPromotor) {
                return this.service
                .findUsuariosNaoAssociadosPromotor(column, order, page, limit, idempresa, ...params);
            }else if (this.isDespesa) {
                return this.service
                .findUsuariosNaoAssociadosDespesas(column, order, page, limit, idempresa, ...params);
            }else {
                return this.service
                .findUsuariosNaoAssociadosAgro(column, order, page, limit, idempresa, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idempresa: this.idempresa,
                    idusuario: m.idusuario,
                    codigo: m.idusuarioerp,
                    nome: m.nome
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.usuariosSelecionados.length > 0) {
                this.isLoading = true;
                this.checkUserSelfUpdate();

                this.saveUsuario()
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);

                        // Caso o usuário modifique a si mesmo é necessário recarregar a aplicação
                        if (this.userSelfUpdate){
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },
        saveUsuario() {
            if (this.isVenda) return this.service.saveVendas(this.usuariosSelecionados);
            else if (this.isPromotor) return this.service.savePromotor(this.usuariosSelecionados);
            else if (this.isDespesa) return this.service.saveDespesas(this.usuariosSelecionados);
            else return this.service.saveAgro(this.usuariosSelecionados);
        },
        checkUserSelfUpdate() {
            this.userSelfUpdate =
                this.usuariosSelecionados.some(user =>
                    `${user.idusuario}` == this.$store.state.user.idusuarioerp ||
                    `${user.codigo}` == this.$store.state.user.idusuarioerp
                )
        },
    },
    watch: {
        // alerta o usuário que a pagina será recarregada ao vincular seu usuário
        usuariosSelecionados(newSelect, oldSelect){
            let user = newSelect[newSelect.length - 1];
            if(!user) return

            if (
                `${user.idusuario}` == this.$store.state.user.idusuarioerp ||
                `${user.codigo}` == this.$store.state.user.idusuarioerp
            ){
                this.msgs.push(new Message("alert", 'msg-alterar-usuario-logado-vinculo', true));
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
